import { render, staticRenderFns } from "./EmailSenderForm.vue?vue&type=template&id=381843ee&"
import script from "./EmailSenderForm.vue?vue&type=script&lang=js&"
export * from "./EmailSenderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('381843ee')) {
      api.createRecord('381843ee', component.options)
    } else {
      api.reload('381843ee', component.options)
    }
    module.hot.accept("./EmailSenderForm.vue?vue&type=template&id=381843ee&", function () {
      api.rerender('381843ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/email/EmailSenderForm.vue"
export default component.exports